export const PREVIOUS_PAGE = "PREVIOUS_PAGE";
export const PAGE_NOT_FOUND_ALERT_TYPE = "PAGE_NOT_FOUND_ALERT_TYPE";
export const MIN_LENGTH_DESCRIPTION = 50;
export const MAX_LENGTH_DESCRIPTION = 200;
